import { render } from "./ClientesList.vue?vue&type=template&id=a4bb4360&scoped=true"
import script from "./ClientesList.vue?vue&type=script&lang=js"
export * from "./ClientesList.vue?vue&type=script&lang=js"

import "./ClientesList.vue?vue&type=style&index=0&id=a4bb4360&scoped=true&lang=scss"

import exportComponent from "/Users/rogeriolugaoveltem/Documents/mtex_nesher_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4bb4360"]])

export default __exports__